import {IPayment} from 'app/blocks/model/payment.model';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {ActionMeta, IEntityAction} from 'app/blocks/store/actions/entity-actions';

export interface IUpdatePaymentAllocated extends IEntityAction {
    entity?: IPayment;
}

export class UpdatePaymentAllocated implements IUpdatePaymentAllocated {
    static readonly type = '[Payment] Update Payment';
    constructor(
        public resource: AbstractEntityResource<any>,
        public entity: IPayment,
        meta?: ActionMeta
    ) {}
}
